export default {
    methods: {
        startRdtTimer() {
            return this.$store.dispatch('v4/rdt/startTimer')
        }
    }
}
